module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-12.6aab65fd.svg";